export default __webpack_public_path__ + "static/media/20Years_1.06da1746.jpg";